<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Admitcards</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row mb-3">
          <!-- Select Section -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
              size="large"
                v-model="selectedSection"
                placeholder="All sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined">All Sections</a-select-option>
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3 pr-md-0">
                <vue-custom-scrollbar class="student-scroll-area">
                    <div class="text-right mb-3">
                      <a-input-search
                        v-model="search"
                        placeholder="Search Students.."
                        size="large"
                        @search="searchStudents"
                        @change="searchStudents"
                      />
                    </div>
                    <students-list :data="data" :loading="loading" @studentSelected="handleStudentSelection" />

                </vue-custom-scrollbar>
                <div class="pt-3 pr-md-2">
                  <a-pagination
                    :total="meta.total"
                    :pageSize.sync="pageSize"
                    v-model="current"
                    @change="onChange"
                  >
                  </a-pagination>
                </div>
              </div>

              <div class="col-md-9 border-left">
                <admit-card-preview :student="selectedStudent" :examData="classSectionExamData"/>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import StudentsList from '@/components/exam/admitcard/List/index'
import AdmitCardPreview from '@/components/exam/admitcard/Preview/index'

import vueCustomScrollbar from 'vue-custom-scrollbar'

import { debounce } from 'lodash'

export default {
  components: {
    StudentsList,
    AdmitCardPreview,
    vueCustomScrollbar,
  },
  mounted: function() {
    this.getClassExamData()
  },
  created() {
    this.searchStudents = debounce(this.searchStudents, 500)
  },
  computed: {
    classSectionExamId: function () {
      return this.$route.params.id
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      classSectionExamData: null,
      data: [],
      meta: {},
      sections: [],
      sectionSpinning: false,
      current: 1,
      pageSize: 15,
      search: null,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      selectedStudent: undefined,
    }
  },
  methods: {
    getClassExamData: function() {
      this.loading = true
      this.$http.get(`/api/classsectionexam/${this.classSectionExamId}`, {
        params: {
          with_students: 0,
          class_section_exam_id: this.classSectionExamId,
        },
      })
        .then(({ data }) => {
          this.classSectionExamData = data.data
          this.selectedClass = data.data.class_id
          this.selectedSession = data.data.session_id
          this.loading = false

          this.getClassSections(data.data.class_id)
          this.getStudents()
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    getStudents: function() {
      this.selectedStudent = null
      this.loading = true
      this.$http.get('/api/student', {
        params: {
          limit: this.pageSize,
          page: this.current,
          search: this.search,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchStudents: function(e) {
      this.getStudents()
    },
    handleCreated: function() {
      this.getStudents()
    },
    handleStudentSelection: function(student) {
      this.selectedStudent = student
    },
    handleTemplateSelection: function(template) {
      console.log(template)
      this.selectedTemplate = template
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStudents()
    },
    onChange(current) {
      this.current = current
      this.getStudents()
    },
    getClassSections(value) {
      this.sectionSpinning = true
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getStudents()
      } else {
        this.selectedSection = undefined
        this.getStudents()
      }
    },
    handleBackButton() {
      this.$router.push({ name: 'manageexam' })
    },
  },
}
</script>
<style lang="scss">
  .student-scroll-area {
    position: relative;
    height: 85vh;
    padding-right: 1rem;
    overflow: auto;
  }
</style>
